export const formatPct = (value: number | null | undefined): string => {
  if (value == null || Number.isNaN(value)) return '—';
  const fixed = value.toFixed(2).replace('.', ',');
  return `${fixed}%`;
};

export const formatDias = (value: number | null | undefined): string => {
  if (value == null || Number.isNaN(value)) return '—';
  return value === 1 ? `${value} dia` : `${value} dias`;
};
